import { User, ClientUser } from '../types';

/**
 * Convert User object to ClientUser by removing sensitive permission flags
 * Use this when storing user data in localStorage
 */
export const toClientUser = (user: User): ClientUser => {
  const { is_superuser: _superuser, is_staff: _staff, ...clientUser } = user;
  return clientUser;
};

/**
 * Convert ClientUser to User with default permissions
 * Only use this as a fallback, permissions should always come from the API
 */
export const toUser = (clientUser: ClientUser, isSuperUser: boolean = false): User => {
  return {
    ...clientUser,
    is_superuser: isSuperUser
  };
};